export const GOOGLE_PASSWORD_RESET_MESSAGE = 'This account uses Google sign-in. Use Continue with Google instead of resetting a password.'

export const shouldBlockPasswordReset = (check) => Boolean(check?.federatedGoogle)
